export default __webpack_public_path__ + "images/msaserversigninlottie_1_3d083580250617a018ea8c7b7a76f40c.json";